module.exports = __webpack_public_path__ + "img/120.826c0084.jpg";